import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUpdateSwFailed = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 200,
	height: 140,
	viewBox: "0 0 200 140",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 200,
			height: 140,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M87.4976 25.5021C68.062 43.8068 62.8206 57.6083 47.1726 65.8731C37.2226 71.1285 25.767 74.9868 19.8893 84.5823C-1.51919 119.532 44.1152 148.28 73.4972 114C98.4156 84.9275 136.624 152.34 172.997 97.5C205.496 48.5007 138.997 -23.0008 87.4976 25.5021Z",
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 88,
			cy: 120,
			r: 6,
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 39,
			cy: 35,
			r: 8,
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M76 25H115C121.075 25 126 29.9249 126 36V36C126 42.0751 121.075 47 115 47H60.75C54.8129 47 50 51.8129 50 57.75V57.75C50 63.6871 54.8129 68.5 60.75 68.5H139.5C145.575 68.5 150.5 73.4249 150.5 79.5V79.5C150.5 85.5751 145.575 90.5 139.5 90.5H87.75C81.2607 90.5 76 95.7607 76 102.25V102.25C76 108.739 81.2607 114 87.75 114H107",
			stroke: "url(#paint0_linear_6332_14210)",
			strokeWidth: 5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 73.5,
			cy: 68.5,
			r: 12.5,
			fill: "url(#paint1_linear_6332_14210)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 95.5,
			cy: 47.5,
			r: 8.5,
			fill: "url(#paint2_linear_6332_14210)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 76,
			cy: 25,
			r: 6,
			fill: "url(#paint3_linear_6332_14210)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 150,
			cy: 81,
			r: 6,
			fill: "url(#paint4_linear_6332_14210)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M129.333 114C129.333 121.364 123.364 127.333 116 127.333C108.636 127.333 102.667 121.364 102.667 114C102.667 106.636 108.636 100.667 116 100.667C123.364 100.667 129.333 106.636 129.333 114Z",
			fill: "#DB5543",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M116 106.333C116.552 106.333 117 106.781 117 107.333V115.333C117 115.886 116.552 116.333 116 116.333C115.448 116.333 115 115.886 115 115.333V107.333C115 106.781 115.448 106.333 116 106.333ZM116 118.333C116.552 118.333 117 118.781 117 119.333V120.667C117 121.219 116.552 121.667 116 121.667C115.448 121.667 115 121.219 115 120.667V119.333C115 118.781 115.448 118.333 116 118.333Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_6332_14210",
				x1: 53.8326,
				y1: 29.5254,
				x2: 132.356,
				y2: 119.04,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#865E9C" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#B69CC4"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_6332_14210",
				x1: 61.9534,
				y1: 57.2712,
				x2: 84.1992,
				y2: 79.7288,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6BCABA" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#ACE1D8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_6332_14210",
				x1: 87.6483,
				y1: 39.8644,
				x2: 102.775,
				y2: 55.1356,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6BCABA" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#ACE1D8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_6332_14210",
				x1: 70.4576,
				y1: 19.6102,
				x2: 81.1356,
				y2: 30.3898,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6BCABA" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#ACE1D8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_6332_14210",
				x1: 144.458,
				y1: 75.6102,
				x2: 155.136,
				y2: 86.3898,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6BCABA" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#ACE1D8"
				})]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgUpdateSwFailed);
export { ForwardRef as ReactComponent };
